import React from "react";
import "../styles/media-added.css";

export const MediaAdded = () => {
  return (
    <>
      <div className="page-container">
        <h1 className="s48px">Your Social Media Account has been added!</h1>

        {/* <!--svg image--> */}
        <div className="svg-container">
          <svg
            className="added-icon"
            width="358"
            height="304"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M305.034 104.2c3.83 7.533 6.849 15.302 15.297 15.302a15.305 15.305 0 0010.817-26.123 15.296 15.296 0 00-10.817-4.482c-8.586-.107-22.426 1.282-15.297 15.303z"
              fill="#2F2E41"
            />
            <path
              d="M317.058 288.232l-6.538 1.457-8.73-24.531 9.648-2.151 5.62 25.225z"
              fill="#F199A5"
            />
            <path
              d="M320.137 294.2l-21.08 4.699-.059-.267a8.403 8.403 0 011.11-6.339 8.422 8.422 0 012.265-2.373 8.415 8.415 0 013.001-1.324h.001l12.875-2.871 1.887 8.475z"
              fill="#2F2E41"
            />
            <path
              d="M336.479 297h-6.698l-3.187-25.843h9.886L336.479 297z"
              fill="#F199A5"
            />
            <path
              d="M338.187 303.495H316.59v-.274c0-1.104.217-2.197.639-3.218a8.417 8.417 0 014.55-4.551 8.415 8.415 0 013.217-.64l13.191.001v8.682zM336.523 283.457h-8.549a2.47 2.47 0 01-2.435-2.126l-7.749-59.962a.82.82 0 00-1.604-.101l-4.592 17.122 4.139 38.995a2.456 2.456 0 01-1.889 2.68l-6.781 1.565a2.47 2.47 0 01-2.897-1.657l-10.921-37.91a21.378 21.378 0 01-.888-8.606l3.416-34.176.259.013 45.615 2.199-2.667 79.591a2.452 2.452 0 01-2.457 2.373z"
              fill="#2F2E41"
            />
            <path
              d="M319.578 119.8c7.411 0 13.419-6.009 13.419-13.423 0-7.413-6.008-13.423-13.419-13.423-7.411 0-13.418 6.01-13.418 13.423 0 7.414 6.007 13.423 13.418 13.423z"
              fill="#F199A5"
            />
            <path
              d="M340.626 205.174c-.044 0-.089-.001-.133-.004l-45.481-2.446a2.457 2.457 0 01-2.208-3.209l3.6-11.181a72.364 72.364 0 001.91-37.095 23.158 23.158 0 014.111-18.661 22.805 22.805 0 0116.478-9.098 23.042 23.042 0 0124.815 26.378l-3.171 21.299 2.528 31.36a2.442 2.442 0 01-.643 1.865 2.445 2.445 0 01-1.806.792z"
              fill="#CCC"
            />
            <path
              d="M284.661 208.005a5.495 5.495 0 00.858-8.383l8.757-17.455-10.075 1.193-6.772 16.393a5.528 5.528 0 00-.048 7.339 5.522 5.522 0 007.28.913zM344.777 210.849a5.496 5.496 0 01.555-8.408l-5.717-18.674 9.733 2.861 3.938 17.294a5.528 5.528 0 01-1.179 7.244 5.522 5.522 0 01-7.33-.317z"
              fill="#F199A5"
            />
            <path
              d="M343.831 201.067a2.447 2.447 0 01-2.434-2.136l-4.55-34.334-7.258-26.83a7.751 7.751 0 013.922-8.913 7.757 7.757 0 013.37-.864 7.785 7.785 0 017.831 6.447l10.814 63.365a2.458 2.458 0 01-2.32 2.871l-9.268.392a3.891 3.891 0 01-.107.002zM289.536 197.211c-.176 0-.351-.019-.523-.055l-9.072-1.936a2.442 2.442 0 01-1.631-1.2 2.471 2.471 0 01-.177-2.018l21.248-60.666a7.791 7.791 0 018.798-5.048 7.755 7.755 0 015.556 10.859l-11.651 25.272-10.209 33.058a2.444 2.444 0 01-2.339 1.734z"
              fill="#CCC"
            />
            <path
              d="M305.339 98.791a18.255 18.255 0 0010.43 3.225 11.193 11.193 0 01-4.433 1.824 36.793 36.793 0 0015.032.084 9.717 9.717 0 003.147-1.081 3.987 3.987 0 001.942-2.598c.33-1.885-1.138-3.597-2.664-4.751a19.648 19.648 0 00-16.512-3.301c-1.845.477-3.693 1.283-4.891 2.765-1.198 1.481-1.553 3.766-.411 5.292l-1.64-1.459z"
              fill="#2F2E41"
            />
            <path
              d="M235.319 0H4.764A4.768 4.768 0 000 4.766v224.793a4.772 4.772 0 004.764 4.766H24.98v-1.361H4.764a3.407 3.407 0 01-3.404-3.405V4.766A3.41 3.41 0 014.764 1.36H235.32a3.409 3.409 0 013.409 3.405v224.793a3.368 3.368 0 01-.563 1.869 3.513 3.513 0 01-1.289 1.159 3.385 3.385 0 01-1.557.377h-20.215v1.361h20.215a4.758 4.758 0 003.726-1.804 4.46 4.46 0 00.683-1.153c.24-.573.362-1.188.36-1.809V4.766A4.77 4.77 0 00235.319 0z"
              fill="#3F3D56"
            />
            <path
              d="M239.405 19.102H.679v1.363h238.726v-1.363zM12.255 14.307a4.086 4.086 0 10-.001-8.176 4.086 4.086 0 00.001 8.176zM24.002 14.307A4.086 4.086 0 1024 6.134a4.086 4.086 0 00.002 8.173zM35.748 14.307a4.086 4.086 0 10-.001-8.173 4.086 4.086 0 00.001 8.173zM177.683 50.638H62.405a7.101 7.101 0 01-7.102-7.105 7.106 7.106 0 017.102-7.105h115.278a7.102 7.102 0 017.102 7.105 7.105 7.105 0 01-7.102 7.105zM62.405 37.522a6.009 6.009 0 00-6.01 6.011 6.013 6.013 0 006.01 6.012h115.278a6.009 6.009 0 006.009-6.012 6.013 6.013 0 00-6.009-6.011H62.405zM206.912 149.882H33.176a9.296 9.296 0 01-9.288-9.291V84.847a9.303 9.303 0 019.288-9.291h173.736a9.296 9.296 0 019.287 9.29v55.745a9.3 9.3 0 01-9.287 9.291zM33.176 76.649a8.202 8.202 0 00-8.195 8.198v55.744a8.205 8.205 0 008.195 8.198h173.736a8.203 8.203 0 008.195-8.198V84.847a8.205 8.205 0 00-8.195-8.198H33.176z"
              fill="#3F3D56"
            />
            <path
              d="M142.827 109.713H82.183a4.37 4.37 0 01-4.37-4.372 4.37 4.37 0 014.37-4.372h60.644a4.368 4.368 0 014.37 4.372 4.372 4.372 0 01-4.37 4.372zM199.1 124.469H82.183a4.37 4.37 0 01-4.37-4.372 4.37 4.37 0 014.37-4.372H199.1a4.37 4.37 0 014.37 4.372 4.372 4.372 0 01-4.37 4.372zM53.008 129.115c9.052 0 16.39-7.341 16.39-16.396s-7.338-16.395-16.39-16.395-16.39 7.34-16.39 16.395 7.338 16.396 16.39 16.396z"
              fill="#010101"
            />
            <path
              d="M199.093 142.231h-15.297a4.37 4.37 0 01-4.371-4.372 4.372 4.372 0 014.371-4.372h15.297a4.371 4.371 0 110 8.744z"
              fill="#fff"
            />
            <path
              d="M199.093 142.231h-15.297a4.37 4.37 0 01-4.371-4.372 4.372 4.372 0 014.371-4.372h15.297a4.371 4.371 0 110 8.744z"
              fill="#CCC"
            />
            <path
              d="M206.909 176.115H33.174a9.304 9.304 0 00-9.288 9.291v55.745a9.303 9.303 0 009.288 9.29h173.735a9.302 9.302 0 009.288-9.29v-55.745a9.296 9.296 0 00-9.288-9.291zm8.195 65.036a8.2 8.2 0 01-8.195 8.197H33.174a8.206 8.206 0 01-8.195-8.197v-55.745a8.209 8.209 0 018.195-8.198h173.735a8.2 8.2 0 018.195 8.198v55.745z"
              fill="#3F3D56"
            />
            <path
              d="M142.827 210.272H82.183a4.37 4.37 0 01-4.37-4.372 4.373 4.373 0 014.37-4.372h60.644a4.368 4.368 0 014.37 4.372 4.372 4.372 0 01-4.37 4.372zM199.1 225.028H82.183a4.37 4.37 0 01-4.37-4.372 4.373 4.373 0 014.37-4.372H199.1a4.37 4.37 0 014.37 4.372 4.372 4.372 0 01-4.37 4.372zM53.008 229.674c9.052 0 16.39-7.341 16.39-16.396s-7.338-16.395-16.39-16.395-16.39 7.34-16.39 16.395 7.338 16.396 16.39 16.396z"
              fill="#010101"
            />
            <path
              d="M199.093 242.79h-15.297a4.374 4.374 0 01-3.091-7.464 4.37 4.37 0 013.091-1.28h15.297a4.371 4.371 0 110 8.744z"
              fill="#CCC"
            />
            <path
              d="M357.454 304h-76.488a.547.547 0 010-1.093h76.488a.548.548 0 01.546.546.548.548 0 01-.546.547z"
              fill="#3F3D56"
            />
          </svg>
        </div>

        {/* <!--Return to home page message--> */}
        <div className="return-to-home">
          <div className="s26px">
            Check out your social media digest from the home page
          </div>
          <div class="home-button-container">
            <div className="button-primary btn white s18px">Configure</div>
            <div className="button-primary btn white s18px">Settings</div>
          </div>
        </div>
      </div>
    </>
  );
};
